import { render, staticRenderFns } from "./KTextarea.vue?vue&type=template&id=b057f446&"
import script from "./KTextarea.vue?vue&type=script&lang=ts&"
export * from "./KTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports